export const removeStyle=(state)=>{
    state.BgStyle=false;
 }


export const  addStyle=(state)=>{
    state.BgStyle=true;
}


export const changeRouterID=(state,prop)=>{
    state.routerID=prop;
}

export const showBlackmask=(state)=>{
    state.blackmask=true;
}

export const removeBlackmask=(state)=>{
    state.blackmask=false;
}

export const getDropDom=(state,prop)=>{
    state.dropDom=prop;
}

export const getUserID=(state,prop)=>{
    state.userID=prop;
}

export const getUserName=(state,prop)=>{
    state.userName=prop;
}

export const getUserAvatar=(state,prop)=>{
    state.userAvatar=prop;
}